export default "__VITE_ASSET__DQVmC1Px__"